import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    loadingNum: 0,
    showLoading: false,
    loadingText:''
  },
  getters: {},
  mutations: {
    setLoading(state,params) {
      if (params == "add") {
        state.loadingNum += 1
      }
      if (params == "minus") {
        state.loadingNum -= 1
      }
      if(state.loadingNum == 0){
        state.showLoading = false
      }else{
        state.showLoading = true
      }
    },
    setLoadingText(state,params){
        state.loadingText = params
    }
  },
  actions: {},
  modules: {},
});
